type FormLayoutTypes =
  | 'text'
  | 'textarea'
  | 'dropdown'
  | 'checkbox'
  | 'checkbox-single'
  | 'checkbox-single-with-label'
  | 'next'
  | 'radio'
  | 'button'
  | 'formLayoutOptions'
  | 'chip-List'
  | 'addButton'
  | 'delButton';

type additionalOptionsType =
  | 'menuOption'
  | 'ExternalLinkOption'
  | 'multipleChoice'
  | 'paymentOption'
  | 'touchResult';

type LayoutType = 'multiple' | 'single' | 'default';

export class DynamicForm {
  layout: FormLayout[];
}

export class FormLayout {
  type: FormLayoutTypes;
  name: string;
  label: string;
  attribute?: FormAttributes;
  value?: string;
  options?: FormOptions[];
  validators?: FormValidators;
  layoutType?: LayoutType;
  default?: additionalOptions[];
  additionalOptionsType?: additionalOptionsType;
  additionalOptions?:
    | additionalOptions[]
    | Array<additionalOptions[]>
    | Map<string, Array<additionalOptions[]>>;
}

export class FormOptions {
  key: string;
  label: string;
  value?: string;
}

export class additionalOptions {
  type: FormLayoutTypes;
  name: string;
  label: string;
  value?: string;
  attribute?: FormAttributes;
  options?: FormOptions[];
  validators?: FormValidators;
}

export class FormValidators {
  required?: boolean;
  maxLength?: number;
  hasDuplicates?: boolean;
  duplicated?: boolean;
  optionSelected?: boolean;
  nextStepValidator?: boolean;
  spaceOnName?: boolean;
}

export class FormAttributes {
  disabled?: boolean;
  display?: boolean;
}
